import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import PropTypes from 'prop-types';
import moment from 'moment';
import IconShape from '../../../../images/notifications/icon-shape.svg';
import IconClock from '../../../../images/notifications/icon-clock.svg';
import {
  NewsItemStyled,
  NewsButtonContainer,
  NewsHeader,
  NewsBody,
  NewsBodyHeader,
  NewsBodyHeaderLeftContent,
  NewsBodyHeaderRightContent,
  NewsBodyContent,
} from './styles/NewsItemStyled';
import { redirectToExternalPage } from '../../../../helpers';

const NewsItem = ({
  title,
  image,
  label,
  body,
  callToAction,
  callToActionLink,
  updatedAt,
}) => {
  let dateLabel = '';
  const dateDiff = moment().diff(updatedAt, 'days');

  if (dateDiff === 0) {
    dateLabel = 'justo ahora';
  } else if (dateDiff === 1) {
    dateLabel = 'hace 1 día';
  } else {
    dateLabel = `hace ${dateDiff} días`;
  }

  return (
    <NewsItemStyled>
      <NewsHeader>
        <div>
          <img src={image} alt="main" />
        </div>
      </NewsHeader>
      <NewsBody>
        <NewsBodyHeader>
          <NewsBodyHeaderLeftContent>
            <img src={IconShape} alt="label" />
            <h3>{label}</h3>
          </NewsBodyHeaderLeftContent>
          <NewsBodyHeaderRightContent>
            <img src={IconClock} alt="date" />
            <h4>{dateLabel}</h4>
          </NewsBodyHeaderRightContent>
        </NewsBodyHeader>
        <NewsBodyContent>
          <h2>{title}</h2>
          {documentToReactComponents(body)}
        </NewsBodyContent>
        {callToAction && callToActionLink ? (
          <NewsButtonContainer>
            <button
              type="button"
              onClick={() => redirectToExternalPage(callToActionLink, true)}
            >
              {callToAction}
            </button>
          </NewsButtonContainer>
        ) : null}
      </NewsBody>
    </NewsItemStyled>
  );
};

NewsItem.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  body: PropTypes.objectOf(PropTypes.shape).isRequired,
  callToAction: PropTypes.string,
  callToActionLink: PropTypes.string,
  updatedAt: PropTypes.string.isRequired,
};

NewsItem.defaultProps = {
  callToAction: null,
  callToActionLink: null,
};

export default NewsItem;
